module.exports = "./app-dist/templates/distributor-pricing-modal.controller.bf68209634d6a6c4332d8b7b31d0aedf.html";